import { render, staticRenderFns } from "./ValidarEmail.vue?vue&type=template&id=8470ba72&"
import script from "./ValidarEmail.vue?vue&type=script&lang=js&"
export * from "./ValidarEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports